import React from 'react';
import {useState} from "react";
import {useDispatch} from "react-redux";
import {addNews} from "./newsList/news_slice";
import {useSelector} from "react-redux";
import {v4} from "uuid"
import useHttp from "../hooks/useHttp";
function NewsAddForm() {
    const {request} = useHttp()
    const dispatch = useDispatch()
    const id = v4()
    const [name,setName] = useState('')
    const[category,setCategory] = useState('')
    const {filters,filterLoadingStatus} = useSelector(state=>state.filter)
    const[description,setDescription] = useState('')
    const addNewNews = (e)=>{
        const newNews = {id,name,category,description}
     e.preventDefault()
        request(' http://localhost:3001/news',
            "POST",
            JSON.stringify(newNews)
            )
            .then(dispatch(addNews(newNews)))
        setCategory("")
        setName("")
        setDescription("")
    }

    const renderFilters = (filters,status)=>{
       if(status==="loading"){
           return <option>Loading options</option>
       }else if(status==="error"){
           return <option>Error options</option>
       }
       if(filters && filters.length>0){
           return filters.map(({name,label})=>{
               //eslint-disable-next-line
               if(name==="all") return;
               return <option key={name} value={name}>{label}</option>
           })
       }
    }



    return (
        <form  className="border p-4 shadow-lg rounded"  onSubmit={addNewNews}>
         <div className="mb-3">
           <label htmlFor="name" className="form-label fs-4"> Name of  news</label>
           <input type="text"
                  required
                  name="name"
                  className="form-control"
                  id="name" placeholder="what is new about ?"
                  value={name}
                  onChange={(e)=>setName(e.target.value)}
           />
           <div className="mb-3">
               <label htmlFor="text" className="form-label fs-4"> Description</label>
               <textarea name="text"
                         className="form-control"
                         id="text" placeholder="what is your news about?"
                         style={{"height":"120px"}}
                         value={description}
                         onChange={(e)=>setDescription(e.target.value)}
               />
           </div>
           <div className="mb-3">
               <label htmlFor="category" className="form-label">Choose category of news</label>
               <select
                   required className="form-select"
                   name="category"
                   id="category"
                   value={category}
                   onChange={(e)=>setCategory(e.target.value)}
               >
                   <option> Category of News...</option>
                   {renderFilters(filters,filterLoadingStatus)}
               </select>
           </div>
          </div>
            <button type="submit" className='btn btn-dark shadow-lg text-light w-100'>create news</button>
        </form>
    );
}

export default NewsAddForm;